import React from 'react';
import { ResumenConfiguracionInicial } from './ResumenConfiguracionInicial';
import { bloqueosDelPlan } from '../Utils/cierreConfiguracionInicial';
import { obtenerPrimero } from '../Utils/configuracionInicial.constants';
import { resolverElementoDeValidacion } from '../Utils/navegacionConfiguracionInicial';

export const CierreConfiguracionInicial = ({ intento, pendientes, plan, planVigente, guardando, onIrAElemento, ...resumen }) => {
  const bloqueos = intento && planVigente ? bloqueosDelPlan(plan) : [];
  return <div className="ci-friendly-review">
    {intento && pendientes.length > 0 && <section className="ci-review-attention" role="alert" aria-label="Preguntas pendientes">
      <h2>Antes de terminar, completa estas preguntas</h2>
      <p>Las que omitiste no necesitan respuesta y no modificarán la configuración actual.</p>
      {pendientes.map(({ elemento, codigoOcurrencia }) => <div className="ci-review-attention__item" key={`${elemento.Codigo}:${codigoOcurrencia}`}>
        <strong>{elemento.Titulo}</strong>
        <button type="button" className="ci-review-edit" disabled={guardando} onClick={() => onIrAElemento(elemento.Codigo, codigoOcurrencia)}>Responder →</button>
      </div>)}
    </section>}
    {bloqueos.length > 0 && <section className="ci-review-attention" role="alert" aria-label="Configuraciones que necesitan atención">
      <h2>Esto necesita atención</h2>
      {bloqueos.map((item, i) => {
        const destino = resolverElementoDeValidacion(item, resumen.definicion);
        const ocurrencia = String(obtenerPrimero(item, ['Codigo', 'codigo'], '')).split(':')[1];
        return <div className="ci-review-attention__item" key={i}>
          <div>{destino && <strong>{destino.elemento.Titulo}</strong>}<p>{obtenerPrimero(item, ['Mensaje', 'mensaje'], 'Revisa esta configuración.')}</p></div>
          {destino && <button type="button" className="ci-review-edit" disabled={guardando} onClick={() => onIrAElemento(destino.elemento.Codigo, ocurrencia)}>Corregir →</button>}
        </div>;
      })}
    </section>}
    <details className="ci-review-group">
      <summary><span className="ci-review-group__title"><strong>Consultar mis respuestas</strong><small>Opcional: revisa o cambia alguna respuesta antes de terminar.</small></span><span className="ci-review-group__toggle" aria-hidden="true">⌄</span></summary>
      <div className="ci-review-group__body">
        <ResumenConfiguracionInicial {...resumen} soloDetalle disabled={guardando} onIrAElemento={onIrAElemento} />
      </div>
    </details>
  </div>;
};
